import { ITableColumn } from 'src/app/core/models/table.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { IPuntoCampionamento } from './punti-campionamento.model';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { QueryState } from 'src/app/core/models/query.model';
export const PUNTI_CAMPIONAMENTO_STORICO_ENDPOINT = 'get-storico-by-id';
export const PUNTI_CAMPIONAMENTO_STORICO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PUNTI_CAMPIONAMENTO_STORICO_ENDPOINT);
export const PUNTI_CAMPIONAMENTO_ENDPOINT = 'punti-campionamento';
export const PUNTI_CAMPIONAMENTO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PUNTI_CAMPIONAMENTO_ENDPOINT);
export const PUNTI_CAMPIONAMENTO_SEND_FILE_ENDPOINT = 'elaborazione-piani-controllo';
export const PUNTI_CAMPIONAMENTO_EDIT_DATA_VALIDITA = 'storico-gui-all';
export const PUNTI_CAMPIONAMENTO_STORICO_EXCEL = 'storico';
export const PUNTI_CAMPIONAMENTO_DATI_EXCEL = 'punti-campionamento?page=0&size=99999&sort=uuid,asc';

export const puntiCampionamentoStateConfig: SignalStoreConfig<QueryState<IPuntoCampionamento>> = {
  initState: {
    list: [],
    sort: {
      field: 'uuid',
      direction: 'asc'
    }
  }
}

export const PUNTI_CAMPIONAMENTO_COLUMNS: ITableColumn[] = [
  {
    name: 'id',
    label: 'id',
    field: 'id',
  },
  {
    name: 'uuid',
    label: 'Codice UUID',
    field: 'uuid',
    primaryKey: true,
  },
  {
    name: 'regione',
    label: 'Regione',
    field: 'regione',
    cell: (row: IPuntoCampionamento) => row.regione?.denominazioneRegione,
  },
  {
    name: 'istatRegione',
    label: 'ISTAT Regione',
    field: 'istatRegione',
  },
  {
    name: 'dateStatus',
    label: 'Validità',
    field: 'dateStatus',
    styles: (row: IPuntoCampionamento)=> row.dateStatus=='valido' ? "border-left: 3px solid green" : row.dateStatus=='scaduto' ? "border-left: 3px solid red" : "border-left: 3px solid yellow",
    cell: (row: IPuntoCampionamento) => row.dateStatus?.toUpperCase(),
  },
  {
    name: 'istatComune.denominazioneRegione',
    label: 'Regione',
    field: 'nomeRegione',
      cell: (row: IPuntoCampionamento) => row.nomeRegione,
  },
  {
    name: 'istatComune.denominazione',
    label: 'Comune',
    field: 'comune',
    cell: (row: IPuntoCampionamento) => row.nomeComune,
  },
  {
    name: 'istatComune',
    label: 'ISTAT Comune',
    field: 'istatComune',
  },
  {
    name: 'nomeComune',
    label: 'Comune',
    field: 'nomeComune',
  },
  {
    name: 'tipoPuntoCampionamento',
    label: 'Tipo',
    field: 'tipoPuntoCampionamento',
   // cell: (row: IPuntoCampionamento) => row.puntoCampionamentoTipologia?.descrizione,
  },
  {
    name: 'idPuntoCampionamento',
    label: 'Identificativo',
    field: 'idPuntoCampionamento',
  },
  {
    name: 'idAreraAto',
    label: 'Id. ARERA ATO',
    field: 'idAreraAto',
   // cell: (row: IPuntoCampionamento) => row.areraAto?.ato,
  },
  {
    name: 'idAreraGestore',
    label: 'Id. ARERA Gestore',
    field: 'idAreraGestore',
   // cell: (row: IPuntoCampionamento) => row.areraGestore?.denominazione,
  },
  {
    name: 'codiceAcquedotto',
    label: 'Acquedotto',
    field: 'codiceAcquedotto',
    //cell: (row: IPuntoCampionamento) => row.acquedotto?.descrizione,
  },
  // {
  //   name: 'progressivoLineAcquedottistica',
  //   label: 'Progressivo Acquedotto',
  //   field: 'progressivoLineAcquedottistica'
  // },
  {
    name: 'previsioneAbitantiServiti',
    label: 'Abitanti',
    field: 'previsioneAbitantiServiti'
  },
  {
    name: 'previsionePortata',
    label: 'Portata',
    field: 'previsionePortata'
  },
  {
    name: 'descrizionePunto',
    label: 'Descrizione',
    field: 'descrizionePunto'
  },
  {
    name: 'note',
    label: 'Note',
    field: 'note'
  },
  {
    name: 'wsz',
    label: 'Water Supply Zone',
    field: 'wsz',
   // cell: (row: IPuntoCampionamento) => row.wsz?.descrizione,
  },
  {
    name: 'numeroCampionamentoAnnuoInternoPrevisto',
    label: 'Campionamenti interni annui',
    field: 'numeroCampionamentoAnnuoInternoPrevisto',
  },
  {
    name: 'numeroCampionamentoAnnuoEsterniPrevisto',
    label: 'Campionamenti esterni annui',
    field: 'numeroCampionamentoAnnuoEsterniPrevisto',
  },
];

export const PUNTICAMPIONAMENTO_VISIBLECOLUMNS = [
  'dateStatus',
  'uuid',
  'istatComune.denominazioneRegione',
  'istatComune.denominazione',
  'tipoPuntoCampionamento',
  'idPuntoCampionamento',
  'idAreraAto',
  'idAreraGestore',
  'codiceAcquedotto',
  'descrizionePunto',
  // 'progressivoLineAcquedottistica',
  // 'previsioneAbitantiServiti',
  // 'previsionePortata',
  'wsz',
];
export const PUNTICAMPIONAMENTO_VISIBLECOLUMNS_DASHOBARD = [
  'uuid',
  'istatComune.denominazioneRegione',
  'istatComune.denominazione',
];